import { useMemo } from "react";
import { useGetAvailableActivationDates } from "@features/portIn/hook/useGetAvailableActivationDates";
import {
    computeFilteredNoInstallActivationDates,
    computeFirstNoInstallActivationDate,
} from "@pages/Installation/noInstallActivationDateUtils";

export const useNoInstallSlot = () => {
    const {
        activationDatesList,
        getActivationDates,
        getAvailableActivationDatesState,
    } = useGetAvailableActivationDates();

    const { filteredActivationDateList, firstAvailableDate } = useMemo(() => {
        const filteredActivationDateList = computeFilteredNoInstallActivationDates(activationDatesList);
        const firstAvailableDate = computeFirstNoInstallActivationDate(filteredActivationDateList);

        return { filteredActivationDateList, firstAvailableDate };
    }, [activationDatesList]);

    return {
        firstAvailableDate,
        filteredActivationDateList,
        isLoading: getAvailableActivationDatesState.isLoading,
        error: getAvailableActivationDatesState.error,
        getActivationDates,
    };
};
